import SliderPagination from './SliderPagination';

import './slider-pagination.scss'

export default SliderPagination;